import { render } from "./upload.vue?vue&type=template&id=6d0c98f6&ts=true"
import script from "./upload.vue?vue&type=script&lang=ts"
export * from "./upload.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/jenkins/workspace/WF-cloud-admin-beta/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__